export enum DocuManagersTableMode {
  DEFAULT = 'default',
  NEW_PROJECT = 'newProject',
}
